// src/data/youthCopy.js
//
// What a player under 18 is told about their own results. The scoring is the
// same for everyone (shared/scoringCore.js); only the words change. "At Risk",
// "Running Hot" and "Needs Support" are honest labels for an adult reading a
// dashboard and the wrong first words for a 12-year-old reading theirs.
//
// Presentation only: nothing here is stored, scored or sent anywhere. The ids
// and tier names underneath are unchanged, so the warehouse and the coach
// aggregates see exactly what they always did.

export const YOUTH_QUADRANTS = {
    thriving:      { label: 'Going Well',        description: 'Doing well and feeling good. Keep doing what you are doing.' },
    building:      { label: 'Building',          description: 'Feeling good, with room to grow your game. A good spot to be.' },
    running_hot:   { label: 'Running on Empty',  description: 'Working hard, but the tank is low. Rest counts as training this week.' },
    needs_support: { label: 'Could Use Support', description: 'A tough stretch, on and off the ice. Talking to someone is a good next step.' },
    unknown:       { label: 'Not Yet',           description: 'Not enough answers yet to place you on the map.' }
};

export const YOUTH_TIERS = {
    Healthy: 'Doing Well',
    Mild: 'A Bit Off',
    Elevated: 'Having a Hard Time',
    'At Risk': 'Could Use Support',
    Unknown: 'Not Yet'
};

// The one-line read on the completion screen.
export const YOUTH_PLAIN_READ = {
    thriving: 'Doing well and feeling good. Keep it up.',
    building: "Feeling good, and there's room to grow your game. Good spot to be.",
    running_hot: 'Working hard, but the tank is low. Rest counts as training this week.',
    needs_support: 'A tough stretch, on and off the ice. Rest and support come first, and talking to someone helps.',
    unknown: 'Your results are ready on your home page.'
};

export const youthQuadrant = (q) => (q ? { ...q, ...(YOUTH_QUADRANTS[q.id] || {}) } : q);
export const youthTier = (tier) => YOUTH_TIERS[tier] || tier;
export const YOUTH_ZONE_LABELS = Object.fromEntries(Object.entries(YOUTH_QUADRANTS).map(([id, q]) => [id, q.label]));
